import {inject, Injectable, signal} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {BasicFeedbackModalComponent} from '../../components/basic-feedback-modal/basic-feedback-modal.component';

@Injectable({
  providedIn: 'root'
})
export class BasicModalService {
  readonly dialog = inject(MatDialog);

  showSuccessModal(message: string, actionButtonText?: string, actionButtonCallback?: () => void) {
    return this.dialog.open(BasicFeedbackModalComponent, {
      width: '700px',
      maxWidth: '90vw',
      data: {
        isSuccess: true,
        message: message,
        closeButtonText: 'Luk',
        actionButtonText,
        actionButtonCallback
      }
    });
  }

  showErrorModal(message: string) {
    return this.dialog.open(BasicFeedbackModalComponent, {
      width: '700px',
      maxWidth: '90vw',
      data: {
        isSuccess: false,
        message: message,
        closeButtonText: 'Luk'
      }
    });
  }

}
